import App from "./app";

const routes = [
  {
    type: "collapse",
    key: "app",
    route: "/app/:appId",
    component: <App />,
  },
];

export default routes;
